import React, { useEffect, useState, useContext } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from '../utils/pubsub'
import QuestionSummaryDetail from './QuestionSummaryDetail'
import FormatAssetName from './FormatAssetName'
import FormatQuestionTitle from './FormatQuestionTitle'
import AnswerSummary from './AnswerSummary'


type Props = {
  question: ObjectStringKeyAnyValue
  answersForThisQuestion: Array<ObjectStringKeyAnyValue>
  thisCheckPeriod: ObjectStringKeyAnyValue
  sortedQuestionsAndAnswers: any
  parentQuestion: ObjectStringKeyAnyValue | null
}

function QuestionSummary({
  question,
  answersForThisQuestion,
  thisCheckPeriod,
  sortedQuestionsAndAnswers,
  parentQuestion
}: Props) {

  const {
    tableData,
    currentOrganisation,
    sendMessageToWebsocket
  } = useContext(GlobalContext)
  const navigate = useNavigate()
  const { checkPeriodId } = useParams()
  const [questionAnswer, setQuestionAnswer] = useState<ObjectStringKeyAnyValue | null>(null)
  const [followUpQuestionIds, setFollowUpQuestionIds] = useState<Array<string> | null>(null)
  const [nextQuestionId, setNextQuestionId] = useState<null | string>(null)



  useEffect(() => {
    if (question && question.Id && tableData && tableData.ChecklistAnswers) {
      const answerForThisQuestion = findAnswerForQuestionId(question.Id)
      setQuestionAnswer(answerForThisQuestion)
    }

    // find follow up question ids
    if (tableData && tableData.ChecklistQuestions && question && question.Id) {
      const followUpQuestions = []
      for (const questionId in tableData.ChecklistQuestions) {
        const thisQuestion = tableData.ChecklistQuestions[questionId]
        if (thisQuestion['parentQuestionId'] === question.Id) {
          followUpQuestions.push(questionId)
        }
      }
      setFollowUpQuestionIds(followUpQuestions)
    }
  }, [tableData, question, checkPeriodId])



  const findAnswerForQuestionId = (questionId: string) => {
    let answer: ObjectStringKeyAnyValue | null = null
    for (const answerId in tableData.ChecklistAnswers) {
      const thisAnswer = tableData.ChecklistAnswers[answerId]
      if (thisAnswer.QuestionId === questionId) {
        answer = thisAnswer
      }
    }
    return answer
  }

  function getFollowUpAnswerSummariesForThisAnswer(parentQuestion: any, parentAnswer: ObjectStringKeyAnyValue, sortedQuestionsAndAnswers: Array<ObjectStringKeyAnyValue>) {
    const follow_up_answers: Array<ObjectStringKeyAnyValue> = []

    for (const follow_on_answer of sortedQuestionsAndAnswers) {
      const answer_id = parentAnswer['Id']
      if (follow_on_answer['ParentAnswerId'] && follow_on_answer['ParentAnswerId'] === answer_id) {
        follow_up_answers.push(follow_on_answer)
      }
    }

    if (follow_up_answers.length === 0) return null

    return <>
      {follow_up_answers.map((follow_up_answer: ObjectStringKeyAnyValue, index: number) => {
        const follow_up_question = tableData.ChecklistQuestions[follow_up_answer.QuestionId]
        return <AnswerSummary
          key={index}
          questionAnswer={follow_up_answer}
          checkPeriodId={checkPeriodId}
          question={follow_up_question}
          sortedQuestionsAndAnswers={sortedQuestionsAndAnswers}
          answersForThisQuestion={[]}
          answerNumber={0}
          parentQuestion={parentQuestion}
        />
      })}

    </>
  }

  if (answersForThisQuestion.length === 0) {
    return null
  }

  return <div
    className={`w-full flex flex-col`}
  >

    <div
      className={`w-full flex flex-col gap-2`}
    >
      {answersForThisQuestion.map((answer: ObjectStringKeyAnyValue, repeition_count: number) => {
        const question = tableData.ChecklistQuestions[answer.QuestionId]
        if (answer.ParentAnswerId) {
          // this is a follow up answer, so we don't show it here
          return null
        }

        return <div key={repeition_count}>
          <AnswerSummary

            questionAnswer={answer}
            checkPeriodId={checkPeriodId}
            question={question}
            sortedQuestionsAndAnswers={sortedQuestionsAndAnswers}
            answersForThisQuestion={answersForThisQuestion}
            answerNumber={repeition_count + 1}
            parentQuestion={parentQuestion}
          />
          {getFollowUpAnswerSummariesForThisAnswer(question, answer, sortedQuestionsAndAnswers)}
        </div>
      })}
    </div>


  </div >
}

export default QuestionSummary